import { useEffect } from 'react';
import { useScriptLoad } from './hooks';
import { useAnalytics } from './FueledAnalytics';
import { TRACKING_EVENTS } from './fueled.events';

const EVENTS = [TRACKING_EVENTS.VIEW_ITEM, TRACKING_EVENTS.ADD_TO_CART];

const determinePageType = () => {
  switch (true) {
    case window.location.pathname.includes('/collections'):
      return 'collection';
    case window.location.pathname.includes('/products'):
      return 'product';
    case window.location.pathname.includes('/pages/search'):
      return 'search';
    case window.location.pathname.includes('/pages'):
      return 'page';
    case window.location.pathname.includes('/articles'):
      return 'article';
    case window.location.pathname.includes('/blogs'):
      return 'blog';
    default:
      return 'home';
  }
};

export function FueledPostscriptScript({ withKey: postScriptShopId }) {
  const { register, subscribe } = useAnalytics();
  const ready = register('postscript-script');

  const { status } = useScriptLoad(
    {
      id: `postscript-${postScriptShopId}`,
      src: `https://sdk.postscript.io/sdk.bundle.js?shopId=${postScriptShopId}&rand=${Date.now()}`,
    },
    'head',
    Boolean(postScriptShopId)
  );

  useEffect(() => {
    if (status !== 'ready') return;

    const identify = async (event) => {
      if (event.detail.user_properties?.customer_phone) {
        return window.postscript?.identify({
          phone: event.detail.user_properties.customer_phone,
        });
      }

      return null;
    };

    const viewItemListener = async (event) => {
      const [product] = event.detail.ecommerce.detail.products;

      window.postscript?.event('page_view', {
        shop_id: postScriptShopId,
        url: `${process.env.SITE_URL}${window.location.pathname}`,
        search_params: { variant: Number(product.variant_id) },
        page_type: determinePageType(),
        referrer: document.referrer,
        resource: {
          category: product.category,
          name: product.name,
          price_in_cents: 100 * parseFloat(product.price),
          resource_id: Number(product.product_id),
          resource_type: 'product',
          sku: product.sku,
          variant_id: Number(product.variant_id),
          vendor: product.vendor || '',
        },
      });

      console.log('Postscript Page View Event Fired:', product);
    };

    const addToCartListener = async (event) => {
      const [product] = event.detail.ecommerce.add.products;

      window.postscript.event('add_to_cart', {
        shop_id: postScriptShopId,
        url: `${process.env.SITE_URL}${window.location.pathname}`,
        search_params: { variant: Number(product.variant_id) },
        page_type: determinePageType(),
        referrer: document.referrer,
        resource: {
          category: product.category,
          name: product.name,
          price_in_cents: 100 * parseFloat(product.price),
          resource_id: Number(product.product_id),
          resource_type: 'product',
          sku: product.sku,
          variant_id: Number(product.variant_id),
          vendor: product.vendor || '',
        },
      });

      console.log('Postscript Add to Cart Event Fired:', product);
    };

    const handleEvent = async (event) => {
      await identify(event);

      switch (event.type) {
        case TRACKING_EVENTS.VIEW_ITEM:
          await viewItemListener(event);
          break;
        case TRACKING_EVENTS.ADD_TO_CART:
          await addToCartListener(event);
          break;
        default:
          break;
      }
    };

    const unsubscribeArray = EVENTS.map((event) =>
      subscribe(event, handleEvent)
    );

    ready();

    // eslint-disable-next-line consistent-return
    return () => {
      unsubscribeArray.forEach((unsubscribe) => unsubscribe());
    };
  }, [status]);

  return null;
}
